import React, { useState, useEffect } from 'react';
import './NotificationBanner.css';

function NotificationBanner({ 
  isSupported, 
  permission, 
  onRequestPermission,
  onDismiss 
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user has previously dismissed the banner
    const dismissed = localStorage.getItem('notification-banner-dismissed');
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    // Show banner only if notifications are supported and permission is not yet granted
    if (isSupported && permission === 'default') {
      // Delay showing the banner for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSupported, permission]);

  const handleEnable = async () => {
    const result = await onRequestPermission();
    if (result === 'granted' || result === 'denied') {
      setIsVisible(false);
    }
  };

  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
    localStorage.setItem('notification-banner-dismissed', 'true');
    if (onDismiss) onDismiss();
  };

  const handleRemindLater = () => {
    setIsVisible(false);
    // Don't set localStorage - will show again next session
  };

  if (!isVisible || isDismissed || permission !== 'default') {
    return null;
  }

  return (
    <div className="notification-banner">
      <div className="notification-banner-content">
        <div className="notification-banner-icon">🔔</div>
        <div className="notification-banner-text">
          <h4>Enable Notifications?</h4>
          <p>Get instant alerts when someone wants to join your ride!</p>
        </div>
        <div className="notification-banner-actions">
          <button 
            className="notification-banner-btn primary" 
            onClick={handleEnable}
          >
            Enable
          </button>
          <button 
            className="notification-banner-btn secondary" 
            onClick={handleRemindLater}
          >
            Later
          </button>
          <button 
            className="notification-banner-btn dismiss" 
            onClick={handleDismiss}
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotificationBanner;
